<template>
  <b-row class="footer">
    <b-col cols="12" md="2" class="logo">
      <img src="../assets/images/logo_inoup_white.png" />
    </b-col>
    <b-col cols="12" md="2" class="menu">
      <div class="section-title">اینوآپ</div>
      <router-link :to="{ name: 'about' }">درباره ما</router-link>
      <router-link :to="{ name: 'service' }">خدمات</router-link>
      <router-link :to="{ name: 'scholarship' }">دریافت بورسیه اینوآپ</router-link>
      <router-link to="#">اساتید ما</router-link>
      <router-link :to="{ name: 'company-scholarship' }">خدمات بورسیه اینوآپ</router-link>
    </b-col>
    <b-col cols="12" md="2" class="contact">
      <div class="section-title">تماس با ما</div>
      <p>تلفن : 02174391039</p>
      <p>تهران ، ملاصدرا ، پلاک 229</p>
      <!-- <p>وب سایت: www.cloudware.com</p> -->
    </b-col>
    <b-col cols="12" md="3" class="description">
      <div class="section-title">اینوآپ</div>
      <div class="text">
        مرکز پرورش نیروی انسانی در حوزه فناوری اطلاعات می‌باشد. این مجموعه با هدف تامین نیروی انسانی متخصص مورد نیاز کسب و کارها در مرکز نوآوری کسب و کار در دانشکده مدیریت دانشگاه
        تهران واقع شده است.
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.footer {
  background: #101d42;
  //   display: flex;
  // position: absolute;
  width: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  margin: 0 !important;
  width: 100%;
}

.logo {
  margin: 70px 10% 70px 0;
  display: grid;
  place-items: center;
  img {
    width: 119px;
    // height: 93px;
  }
  border-left: 2px solid #959fb2;
  min-height: 183px;
  //   padding-left: 60px;
}

.menu {
  //   width: 50%;
  margin: 70px 30px 70px 0;
  border-left: 2px solid #959fb2;
  min-height: 183px;
  //   padding-left: 60px;
}

a {
  line-height: 25px;
  color: #fff;
  display: block;
  width: 100%;
}

.contact {
  //   width: 100%;
  margin: 70px 30px 70px 0;
  border-left: 2px solid #959fb2;
  min-height: 183px;
  //   padding-left: 60px;
  p {
    color: #fff;
  }
}

.description {
  //   width: 100%;
  margin: 70px 30px 70px 0px;
  min-height: 183px;
  //   padding-left: 60px;
  .text {
    color: #fff;
    text-align: justify;
  }
}

.section-title {
  font-weight: 400;
  font-size: 15px;
  line-height: 25px;
  text-align: right;
  margin-bottom: 10px;
  color: #ffc833;
}

@media (max-width: 1024px) {
  .col-md-2,
  .col-md-3 {
    width: 100%;
  }

  .contact {
    border-right: 2px solid #959fb2;
  }
  .description {
    border-right: 2px solid #959fb2;
    margin: 0 30px 30px 30px !important;
    padding-left: 50px;
  }
  .menu {
    border-right: 2px solid #959fb2;
    margin-left: 16px;
    margin-bottom: 0;
  }
  .logo {
    margin: 70px 0 20px 0;
    display: block;
    min-height: auto;
    img {
      height: auto;
    }
  }
}
</style>
